import { render } from "./ProjectRazzoFAQ.vue?vue&type=template&id=1ad50b85"
import script from "./ProjectRazzoFAQ.vue?vue&type=script&lang=js"
export * from "./ProjectRazzoFAQ.vue?vue&type=script&lang=js"

import "./ProjectRazzoFAQ.vue?vue&type=style&index=0&id=1ad50b85&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__